import React from 'react';
import { FaGlobe, FaShoppingCart, FaCrown, FaLaptop, FaRocket } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../styles/Packages.css';

const Packages = () => {
  const packages = [
    {
      title: "Starter Package",
      price: "R1,999",
      features: [
        "1–3 Page Website (Home, About, Contact)",
        "Mobile Responsive Design",
        "Basic Contact Form",
        "Social Media Links",
        "5-Day Delivery",
        "1 Round of Revisions"
      ],
      icon: <FaGlobe />
    },
    {
      title: "Basic Package",
      price: "R3,499",
      features: [
        "4–6 Page Website (Home, About, Services, Contact, etc.)",
        "Mobile + Tablet Responsive",
        "Basic SEO Setup",
        "Contact Form with Google Maps",
        "Social Media Integration",
        "7-Day Delivery",
        "2 Rounds of Revisions"
      ],
      icon: <FaLaptop />
    },
    {
      title: "Standard Package",
      price: "R5,999",
      features: [
        "6–10 Pages",
        "Custom Design (No Templates)",
        "Advanced Contact Forms",
        "Blog Setup",
        "Basic On-Page SEO",
        "WhatsApp Chat Button Integration",
        "10-Day Delivery",
        "3 Rounds of Revisions"
      ],
      icon: <FaRocket />
    },
    {
      title: "Business Package",
      price: "R9,999",
      features: [
        "Up to 14 Pages",
        "Premium Custom Design",
        "CMS Setup (WordPress etc.)",
        "Blog + Portfolio Section",
        "Advanced SEO Optimization",
        "E-commerce Ready (up to 10 products)",
        "Live Chat Integration",
        "14-Day Delivery",
        "4 Rounds of Revisions"
      ],
      icon: <FaCrown />
    },
    {
      title: "E-Commerce Package",
      price: "R17,999",
      features: [
        "Full Online Store (Shop, Cart, Checkout, Payments)",
        "Up to 30 Products Uploaded",
        "Payment Gateway Integration (PayFast, Ozow, Yoco)",
        "Stock Management System",
        "Discount Codes/Coupons Setup",
        "Basic SEO for Shop Pages",
        "Order Notification Emails Setup",
        "20-Day Delivery",
        "5 Rounds of Revisions"
      ],
      icon: <FaShoppingCart />
    },
    {
      title: "Premium Custom Solution",
      price: "R21,999",
      features: [
        "16-22 Pages",
        "Fully Custom Built Website",
        "Web App Features (Portals, Bookings, etc.)",
        "Advanced E-commerce (Multi-vendor, Subscriptions)",
        "Integration with CRMs, WhatsApp API, etc.",
        "Advanced SEO + Speed Optimization",
        "1-Month Support & Maintenance",
        "Unlimited Revisions During Design Phase",
        "Timeline Based on Project Size"
      ],
      icon: <FaCrown />
    }
  ];

  return (
    <div className="packages-page container">
      <h1 className="packages-title">Website Service Packages</h1>

      <div className="package-section">
        <div className="card-grid">
          {packages.map((pkg, index) => (
            <div key={index} className="package-card">
              <div className="package-icon">{pkg.icon}</div>
              <h3>{pkg.title}</h3>
              <p className="price">{pkg.price}</p>
              <ul className="features-list">
                {pkg.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <Link
                to={`/quote?package=${encodeURIComponent(pkg.title)}&price=${encodeURIComponent(pkg.price)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="order-now-btn">Order Now</button>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <div className="notes-section">
        <h2>📌 Important Notes</h2>
        <ul>
          <li>Prices exclude hosting & domain services (available as optional add-ons).</li>
          <li>Optional services like <strong>logo design</strong>, <strong>copywriting</strong>, and <strong>monthly maintenance</strong> can be added to any package.</li>
          <li>Hosting + maintenance bundles are available from <strong>R150–R399/month</strong> depending on your needs.</li>
        </ul>
      </div>
    </div>
  );
};

export default Packages;
